/**
 * @Author: Zewei
 * @Date:   2018-01-19T13:59:12+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-01-19T13:59:14+08:00
 */

 import fileNotFound from "../../assets/images/404.svg";
 import unAuthorized from "../../assets/images/401.svg";
 import internalError from "../../assets/images/500.svg";

 const config = {
   403: {
     img: {unAuthorized}.unAuthorized,
     title: '403',
     desc: '抱歉，你无权访问该页面',
   },
   404: {
     img: {fileNotFound}.fileNotFound,
     title: '404',
     desc: '抱歉，你访问的页面不存在',
   },
   500: {
     img: {internalError}.internalError,
     title: '500',
     desc: '抱歉，服务器出错了',
   },
 };

 export default config;



// WEBPACK FOOTER //
// ./src/components/Exception/typeConfig.js